export const USER = 'USER'
export const LOADING = 'USER/LOADING'
export const ERRORS = 'USER/ERRORS'
export const SET_DATA = 'USER/SET_DATA'
export const INFO = 'USER/INFO'
export const UPDATE_USER_INFO = 'USER/UPDATE_USER_INFO'
